import { timeConvert, TimeConvertType } from "../../lib";
import { GarminConnectDataDigest } from "../../store";
import { Color } from "../../store/state/theme/theme_init_state";

export const AdherenceGarminConnectWearTimeElement = (props: {
  garminConnectDataDigest?: GarminConnectDataDigest | null;
  color: Color;
}) => {
  const { garminConnectDataDigest, color } = props;
  if (garminConnectDataDigest) {
    return (
      <div css={{ width: "100%", color: color.black, textAlign: "center" }}>
        {
          timeConvert({
            time: garminConnectDataDigest.wearTime,
            type: TimeConvertType.formatMinutes,
          }) as string
        }
      </div>
    );
  } else {
    return (
      <div css={{ width: "100%", color: color.grey_160, textAlign: "center" }}>
        {garminConnectDataDigest == null ? "No Data" : ""}
      </div>
    );
  }
};
